import { render } from "./memberListPromo.vue?vue&type=template&id=6064a26a&scoped=true"
import script from "./memberListPromo.vue?vue&type=script&lang=js"
export * from "./memberListPromo.vue?vue&type=script&lang=js"

import "./memberListPromo.vue?vue&type=style&index=0&id=6064a26a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6064a26a"]])

export default __exports__